export const API_ROOT = {
  'development': 'http://localhost:8080/',
  'production': 'http://localhost:8080/'
}[process.env.NODE_ENV]
